import { axiosClientv1 } from "./apiClient";
import { ApiResponse } from "../Types";

export const GetActivityLogs = async (params: {
  page: number;
  limit: number;
  search?: string;
  tenant_id?: string;
  method?: string;
  status_code?: string;
  section?: string;
  username?: string;
  start_date?: string;
  end_date?: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/system-admin/activity-logs`, { params });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load activity logs.",
      error: { code: error?.response?.status || 500, type: "server_error" },
    };
  }
};
